import { ApiService } from './api.service';

const BPMService = {
    /**
     * Возвращает список всех процессов
     **/
    getProcessFolder: async function() {
        try {
            let response = await ApiService.get(`v1/process-folder/`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    /**
     * Возвращает список процессов для заданой папки
     **/
    getProcessFolderFolder: async function(folderId) {
        try {
            let response = await ApiService.get(`v1/process-folder/folder/${folderId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    /**
     * Возвращает настройки шага для процесса
     **/
    getProcessesSchemaTask: async function(proccessId, taskId) {
        try {
            let response = await ApiService.get(`v1/processes-schema/${proccessId}/${taskId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    /**
     * Возвращает настройки шага процесса по ID
     **/
    getProcessesSchemaTaskById: async function(Id) {
        try {
            let response = await ApiService.get(`v1/processes-schema/${Id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    /**
     * Стартует указанный процесс и возвращает ID запущенного процесса
     * @param {*} processId - ID типа процесса
     * @param {*} processStartTaskId - ID шага процесса
     */
    postStartNewProcess: async function(processId, processStartTaskId) {
        try {
            let response = await ApiService.post(`v1/process/rest/engine/default/process-definition/key/${processId}/${processStartTaskId}`, {});
            return response.data.id;
        } catch (error) {
            throw error;
        }
    },
    /**
     * Выполняет текущий шаг процесса
     * @param {*} requestProcessId - ID процесса заявки
     * @param {*} data - данные шага
     */
    postTaskCompleteProcess: async function(requestProcessId, data) {
        try {
            let response = await ApiService.post(`v1/process/task/complete?processID=${requestProcessId}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getSchemaByProcessId: async function(requestProcessId) {
        try {
            let response = await ApiService.get(`v1/process/task/getSchema?processID=${requestProcessId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};

export default BPMService;

export { BPMService };
